/**
 * Splits an HTML string into paragraphs by splitting on closing `</p>` tags and `<br>` tags,
 * then strips all remaining HTML tags and trims whitespace.
 */
export const getParagraphs = (htmlStr: string): Array<string> => {
  return htmlStr
    .split(/<\/p>|<br\s*\/?>/)
    .map((part) => {
      const cleanText = part.replace(/<\/?[^>]+(>|$)/g, "");
      return cleanText.trim();
    })
    .filter((p) => p.length > 0);
};
